module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("Chapter 1        The Race Riot of 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2        His Daughter’s Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3        Murder at the Peabody")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4        Tainted Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5        A Husband Scorned")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6        Murder by Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7        Cruel and Unusual")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8        Mistaken Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9        The Summer Avenue Slayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10      The Cigarette Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11      Memphis’s Merry Widow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12      The Assassination of a Dreamer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13      Serial Killer of ’69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14      The Ultimate Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15      A Murder in Millington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16      The West Memphis Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0